<template>
  <div>
    <b-form @submit="onSubmit" v-if="sendStatus == 'init'">
      <form-contact :contact.sync="contact" />
      <div class="form__group field">
        <label for="products" class="form__label">Betreffendes Produkt</label>
        <div>
          <b-form-select id="products" class="form__field" required v-model="selectedProduct" :options="products">
          </b-form-select>
        </div>
      </div>

      <div class="form__group field">
        <label for="body" class="form__label">Ihre Anfrage</label>
        <textarea cols="" rows="7" class="form__field" placeholder="Anfrage" name="body" v-model="body"
          id='body'></textarea>
      </div>

      <!-- Redmine #6960 <form-cc-me :ccme.sync="ccme"/> -->
      <privacy-policy :ppAccepted.sync="ppAccepted" :pnUrl="privacyNoticeUrl" />

      <div class="form__group field text-right">
        <input type="submit" class="btn btn-outline-primary" value="Absenden" :disabled="!ppAccepted" />
      </div>
    </b-form>
    <b-alert show v-else-if="sendStatus == 'pending'">
      <div>
        <i class="fa fa-spin fa-spinner" />
        Wird gesendet
      </div>
    </b-alert>
    <b-alert show variant="success" v-else-if="sendStatus == 'success' && !('error' in response)">
      <div>
        <i class="fa fa-warning" />
        {{ response.data.message }}
      </div>
    </b-alert>
    <b-alert show variant="danger" v-else-if="'error' in response">
      <div>
        <i class="fa fa-warning" />
        {{ response.error.message }}
      </div>
    </b-alert>
    <b-alert show variant="danger" v-else>
      <div>
        <i class="fa fa-warning" />
        Fehler beim Senden
      </div>
    </b-alert>

  </div>
</template>
<script>
import FormContact from "./FormContact.vue";
// import FormCcMe from "./FormCcMe.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue";

export default {
  props: ["apiUrl", "apiPrivacyNoticeUrl"],
  data() {
    return {
      selectedProduct: null,
      products: [],
      contact: {},
      ccme: false,
      ppAccepted: false, // Did the user has accepted the conditions of the privacy policy
      privacyNoticeUrl: this.apiPrivacyNoticeUrl,
      body: "Sehr geehrtes fumiX-Team,\n\n",
      sendStatus: "init",
      response: {}
    };
  },
  asyncComputed: {
    products: {
      get() {
        return this.$http.get(this.apiUrl).then(response => {
          let issueCategories = [];
          let categories = response.body.data;
          categories.forEach(function (category, index) {
            // issueCategories.push({ text: category.name, value: category.id })
            issueCategories.push({ text: category.name, value: category.name })
          })
          return issueCategories;
        });
      },
      default: []
    }
  },
  methods: {
    onSubmit(evt) {
      this.sendStatus = "pending";
      evt.preventDefault();
      $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: Object.assign(
          {
            action: "send"
          },
          this.contact,
          {
            subject: this.selectedProduct,
            body: this.body,
            ccme: this.ccme
          }
        ),
        complete: (req, status) => {
          this.sendStatus = status;
          this.response = JSON.parse(req.responseText);
        }
      });
      this.$el.scrollIntoView();
    }
  },
  components: {
    FormContact,
    // FormCcMe,
    PrivacyPolicy
  }
};
</script>
